export interface Movie {
  id: string;
  title: string;
  enTitle: string;
  year: number;
  category: string;
  genre: string[];
  rating: number;
  poster: string;
  backdrop: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
}

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-movie-line' },
];

export const heroMovies: Movie[] = [
  {
    id: 'hero-1',
    title: '流浪地球3',
    enTitle: 'The Wandering Earth 3',
    year: 2026,
    category: 'movie',
    genre: ['科幻', '灾难', '冒险'],
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20The%20Wandering%20Earth%203%2C%20dramatic%20space%20scene%20with%20Earth%20engines%2C%20cinematic%20lighting%2C%20dark%20atmosphere%2C%20epic%20scale%2C%20movie%20poster%20design%20with%20Chinese%20text%20space%2C%20professional%20film%20poster%20aesthetic&width=400&height=600&seq=hero-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20of%20giant%20Earth%20engines%20in%20space%2C%20massive%20scale%2C%20dramatic%20lighting%20with%20blue%20plasma%20glow%2C%20dark%20space%20background%20with%20stars%2C%20cinematic%20composition%2C%20movie%20quality%20visual%20effects%2C%20atmospheric&width=1600&height=900&seq=hero-backdrop-01&orientation=landscape',
    description: '太阳急速老化，持续膨胀。地球面临被吞没的灭顶之灾。为拯救地球，人类在地球表面建造了上万座行星发动机，以逃离太阳系寻找新的家园，地球和人类就此踏上预计长达2500年的宇宙流浪之旅。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '173分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 2580000,
  },
  {
    id: 'hero-2',
    title: '封神第二部',
    enTitle: 'Creation of the Gods II',
    year: 2026,
    category: 'movie',
    genre: ['奇幻', '史诗', '动作'],
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%20Creation%20of%20the%20Gods%2C%20ancient%20Chinese%20mythological%20warriors%20in%20golden%20armor%2C%20dramatic%20clouds%20and%20divine%20light%2C%20epic%20battle%20scene%2C%20movie%20poster%20design%20with%20calligraphy%20elements&width=400&height=600&seq=hero-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20epic%20battle%20scene%20with%20thousands%20of%20warriors%2C%20golden%20divine%20light%20breaking%20through%20storm%20clouds%2C%20grand%20scale%20fantasy%20cinematography%2C%20dramatic%20atmosphere%2C%20warm%20golden%20tones&width=1600&height=900&seq=hero-backdrop-02&orientation=landscape',
    description: '殷商大军压境，西岐军民在姜子牙的带领下奋起反抗。封神大战一触即发，三界力量交织碰撞，一场关乎天下苍生命运的大战即将拉开帷幕。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    duration: '148分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 3120000,
  },
  {
    id: 'hero-3',
    title: '哪吒之魔童闹海',
    enTitle: 'Nezha: The Devil Child Rages',
    year: 2025,
    category: 'anime',
    genre: ['动画', '奇幻', '喜剧'],
    rating: 9.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20Nezha%20with%20fire%20wheels%20and%20red%20ribbon%2C%20dynamic%20pose%20in%20stormy%20sky%2C%20vibrant%20colors%20red%20and%20gold%2C%20epic%20animation%20style%2C%20cinematic%20lighting%2C%20dramatic%20composition&width=400&height=600&seq=hero-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20animated%20fantasy%20scene%20with%20Nezha%20surrounded%20by%20flames%20and%20divine%20powers%2C%20thunderstorms%20and%20dynamic%20clouds%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20cinematic%20animation%20quality%2C%20dramatic%20lighting&width=1600&height=900&seq=hero-backdrop-03&orientation=landscape',
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，过程中却遭遇重重困难，哪吒与敖丙的命运将何去何从？',
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '囧森瑟夫'],
    duration: '144分钟',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    views: 5200000,
  },
];

export const latestMovies: Movie[] = [
  {
    id: 'movie-1',
    title: '热辣滚烫',
    enTitle: 'YOLO',
    year: 2024,
    category: 'movie',
    genre: ['喜剧', '剧情', '运动'],
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20about%20boxing%20and%20self-discovery%2C%20warm%20lighting%2C%20determined%20female%20protagonist%2C%20inspirational%20tone%2C%20cinematic%20movie%20poster%20design&width=400&height=600&seq=latest-poster-01&orientation=portrait',
    backdrop: '',
    description: '乐莹是一个善良的女孩，在经历了一系列打击后，她决定学习拳击，为自己的人生拼搏一次。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    duration: '129分钟',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    views: 1890000,
  },
  {
    id: 'movie-2',
    title: '第二十条',
    enTitle: 'Article 20',
    year: 2024,
    category: 'movie',
    genre: ['剧情', '法律'],
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20about%20justice%20and%20courtroom%2C%20serious%20tone%2C%20professional%20actors%20in%20suits%2C%20dramatic%20lighting%2C%20cinematic%20poster%20design&width=400&height=600&seq=latest-poster-02&orientation=portrait',
    backdrop: '',
    description: '以一个基层检察官的视角，讲述《刑法》第二十条"正当防卫"条款背后的法与情。',
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖', '高叶'],
    duration: '141分钟',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    views: 1450000,
  },
  {
    id: 'movie-3',
    title: '飞驰人生2',
    enTitle: 'Pegasus 2',
    year: 2024,
    category: 'movie',
    genre: ['喜剧', '运动'],
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20cars%20and%20desert%20landscape%2C%20dynamic%20action%20feel%2C%20humorous%20undertone%2C%20cinematic%20poster%20design%20with%20warm%20desert%20colors&width=400&height=600&seq=latest-poster-03&orientation=portrait',
    backdrop: '',
    description: '昔日冠军车手张驰沦为落魄驾校教练，濒临停产的老头乐车厂厂长主动提出赞助张驰组建车队再战最后一届巴音布鲁克拉力赛。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜'],
    duration: '121分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 2100000,
  },
  {
    id: 'movie-4',
    title: '熊出没·逆转时空',
    enTitle: 'Boonie Bears: Time Twist',
    year: 2024,
    category: 'anime',
    genre: ['动画', '喜剧', '冒险'],
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%20with%20bears%20and%20time%20travel%20theme%2C%20colorful%20vibrant%20colors%2C%20fun%20adventure%20feel%2C%20animated%20movie%20poster%20design%20for%20children&width=400&height=600&seq=latest-poster-04&orientation=portrait',
    backdrop: '',
    description: '光头强和熊大熊二意外穿越时空，为了回到原来的世界，他们必须完成一系列挑战。',
    director: '林汇达',
    actors: ['谭笑', '张伟', '张秉君'],
    duration: '108分钟',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 980000,
  },
  {
    id: 'movie-5',
    title: '奥本海默',
    enTitle: 'Oppenheimer',
    year: 2023,
    category: 'movie',
    genre: ['传记', '历史', '剧情'],
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Hollywood%20biographical%20drama%20movie%20poster%20about%20nuclear%20physicist%2C%20dark%20moody%20atmosphere%20with%20fire%20and%20explosion%2C%20serious%20tone%2C%20cinematic%20poster%20design%20with%20black%20and%20orange%20contrast&width=400&height=600&seq=latest-poster-05&orientation=portrait',
    backdrop: '',
    description: '聚焦美国"原子弹之父"罗伯特·奥本海默在二战期间主导研制原子弹的过程，以及战后所面临的道德困境。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    duration: '180分钟',
    region: '美国',
    isHot: false,
    isNew: false,
    views: 1750000,
  },
  {
    id: 'movie-6',
    title: '年会不能停！',
    enTitle: 'Johnny Keep Walking!',
    year: 2024,
    category: 'movie',
    genre: ['喜剧', '职场'],
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%20about%20corporate%20annual%20party%2C%20office%20setting%2C%20humorous%20chaotic%20scene%2C%20bright%20office%20lighting%2C%20cinematic%20poster%20design&width=400&height=600&seq=latest-poster-06&orientation=portrait',
    backdrop: '',
    description: '钳工胡建林阴差阳错被调入集团总部，从"蓝领"变"金领"，在职场丛林中引发了一系列啼笑皆非的故事。',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲', '王迅'],
    duration: '117分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 1560000,
  },
  {
    id: 'movie-7',
    title: '沙丘2',
    enTitle: 'Dune: Part Two',
    year: 2024,
    category: 'movie',
    genre: ['科幻', '冒险', '剧情'],
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Hollywood%20sci-fi%20epic%20movie%20poster%20Dune%20Part%202%20with%20desert%20landscape%20and%20giant%20sandworms%2C%20epic%20scale%2C%20warm%20desert%20tones%20orange%20and%20gold%2C%20cinematic%20poster&width=400&height=600&seq=latest-poster-07&orientation=portrait',
    backdrop: '',
    description: '保罗·厄崔迪与弗雷曼人联手，踏上向摧毁他家庭的阴谋者复仇的征程，并努力阻止他预见的可怕未来。',
    director: '丹尼斯·维伦纽瓦',
    actors: ['提莫西·查拉梅', '赞达亚', '丽贝卡·弗格森', '奥斯汀·巴特勒'],
    duration: '166分钟',
    region: '美国',
    isHot: false,
    isNew: false,
    views: 1320000,
  },
  {
    id: 'movie-8',
    title: '周处除三害',
    enTitle: 'The Pig, the Snake and the Pigeon',
    year: 2024,
    category: 'movie',
    genre: ['动作', '犯罪', '剧情'],
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Taiwanese%20action%20crime%20movie%20poster%20with%20dark%20noir%20aesthetic%2C%20intense%20male%20protagonist%2C%20moody%20lighting%2C%20gangster%20theme%2C%20cinematic%20poster%20design%20with%20red%20accents&width=400&height=600&seq=latest-poster-08&orientation=portrait',
    backdrop: '',
    description: '通缉犯陈桂林在得知自己身患绝症后，决定在生命最后时刻除掉排名在自己前面的两大罪犯，以求留名。',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文', '王净'],
    duration: '134分钟',
    region: '中国台湾',
    isHot: true,
    isNew: false,
    views: 1980000,
  },
];

export const hotRanking: Movie[] = [
  {
    id: 'hot-1',
    title: '哪吒之魔童闹海',
    enTitle: 'Nezha: The Devil Child Rages',
    year: 2025,
    category: 'anime',
    genre: ['动画', '奇幻', '喜剧'],
    rating: 9.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20Nezha%20with%20flames%20and%20magical%20powers%2C%20dynamic%20red%20and%20gold%20colors%2C%20epic%20fantasy%20animation%20style%2C%20movie%20poster%20design&width=400&height=600&seq=hot-poster-01&orientation=portrait',
    backdrop: '',
    description: '哪吒与敖丙的天劫之后，灵魂保住但肉身将散，太乙真人用七色宝莲重塑肉身的过程中困难重重。',
    director: '饺子',
    actors: ['吕艳婷', '陈浩'],
    duration: '144分钟',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    views: 5200000,
  },
  {
    id: 'hot-2',
    title: '封神第二部',
    enTitle: 'Creation of the Gods II',
    year: 2026,
    category: 'movie',
    genre: ['奇幻', '史诗', '动作'],
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20Creation%20of%20Gods%20movie%20poster%20with%20warriors%20and%20divine%20creatures%2C%20golden%20armor%2C%20dramatic%20clouds%2C%20cinematic%20design&width=400&height=600&seq=hot-poster-02&orientation=portrait',
    backdrop: '',
    description: '殷商大军压境，西岐军民在姜子牙带领下奋起反抗，封神大战一触即发。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    duration: '148分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 3120000,
  },
  {
    id: 'hot-3',
    title: '流浪地球3',
    enTitle: 'The Wandering Earth 3',
    year: 2026,
    category: 'movie',
    genre: ['科幻', '灾难', '冒险'],
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20The%20Wandering%20Earth%20poster%20with%20space%20engines%20and%20Earth%2C%20dramatic%20dark%20blue%20space%20scene%2C%20epic%20cinematic%20design&width=400&height=600&seq=hot-poster-03&orientation=portrait',
    backdrop: '',
    description: '地球面临被太阳吞没的危机，人类建造行星发动机逃离太阳系，踏上2500年的宇宙流浪之旅。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    duration: '173分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 2580000,
  },
  {
    id: 'hot-4',
    title: '飞驰人生2',
    enTitle: 'Pegasus 2',
    year: 2024,
    category: 'movie',
    genre: ['喜剧', '运动'],
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20car%20in%20desert%2C%20action%20and%20humor%2C%20warm%20desert%20colors%2C%20cinematic%20design&width=400&height=600&seq=hot-poster-04&orientation=portrait',
    backdrop: '',
    description: '昔日冠军车手张驰带队再战巴音布鲁克拉力赛，笑料与热血并存。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正'],
    duration: '121分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 2100000,
  },
  {
    id: 'hot-5',
    title: '周处除三害',
    enTitle: 'The Pig, the Snake and the Pigeon',
    year: 2024,
    category: 'movie',
    genre: ['动作', '犯罪', '剧情'],
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Taiwanese%20action%20crime%20movie%20poster%20with%20gangster%20noir%20style%2C%20intense%20male%20lead%2C%20dark%20moody%20lighting%2C%20cinematic%20design&width=400&height=600&seq=hot-poster-05&orientation=portrait',
    backdrop: '',
    description: '通缉犯陈桂林绝症之际，决定除掉排名在自己前面的两大罪犯以求留名。',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文'],
    duration: '134分钟',
    region: '中国台湾',
    isHot: true,
    isNew: false,
    views: 1980000,
  },
  {
    id: 'hot-6',
    title: '热辣滚烫',
    enTitle: 'YOLO',
    year: 2024,
    category: 'movie',
    genre: ['喜剧', '剧情', '运动'],
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20inspirational%20boxing%20comedy%20movie%20poster%20with%20female%20boxer%2C%20warm%20lighting%2C%20determination%20theme%2C%20cinematic%20design&width=400&height=600&seq=hot-poster-06&orientation=portrait',
    backdrop: '',
    description: '乐莹学习拳击为自己拼搏一次，温暖励志的自我救赎故事。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    duration: '129分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 1890000,
  },
  {
    id: 'hot-7',
    title: '奥本海默',
    enTitle: 'Oppenheimer',
    year: 2023,
    category: 'movie',
    genre: ['传记', '历史', '剧情'],
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Hollywood%20biopic%20Oppenheimer%20movie%20poster%20with%20nuclear%20explosion%20fire%2C%20dark%20intense%20atmosphere%2C%20black%20and%20orange%20contrast%2C%20cinematic%20design&width=400&height=600&seq=hot-poster-07&orientation=portrait',
    backdrop: '',
    description: '"原子弹之父"奥本海默主导研制原子弹及战后道德困境的故事。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特'],
    duration: '180分钟',
    region: '美国',
    isHot: true,
    isNew: false,
    views: 1750000,
  },
  {
    id: 'hot-8',
    title: '第二十条',
    enTitle: 'Article 20',
    year: 2024,
    category: 'movie',
    genre: ['剧情', '法律'],
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20about%20courtroom%20justice%2C%20serious%20tone%2C%20professional%20style%2C%20cinematic%20design&width=400&height=600&seq=hot-poster-08&orientation=portrait',
    backdrop: '',
    description: '基层检察官视角下《刑法》第二十条"正当防卫"背后的法与情。',
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖'],
    duration: '141分钟',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    views: 1450000,
  },
  {
    id: 'hot-9',
    title: '沙丘2',
    enTitle: 'Dune: Part Two',
    year: 2024,
    category: 'movie',
    genre: ['科幻', '冒险', '剧情'],
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Hollywood%20sci-fi%20epic%20Dune%202%20movie%20poster%20with%20desert%20warrior%2C%20epic%20scale%2C%20warm%20orange%20tones%2C%20cinematic%20design&width=400&height=600&seq=hot-poster-09&orientation=portrait',
    backdrop: '',
    description: '保罗与弗雷曼人联手复仇，阻止可怕未来的科幻史诗。',
    director: '丹尼斯·维伦纽瓦',
    actors: ['提莫西·查拉梅', '赞达亚'],
    duration: '166分钟',
    region: '美国',
    isHot: false,
    isNew: false,
    views: 1320000,
  },
  {
    id: 'hot-10',
    title: '年会不能停！',
    enTitle: 'Johnny Keep Walking!',
    year: 2024,
    category: 'movie',
    genre: ['喜剧', '职场'],
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%20about%20office%20chaos%2C%20humorous%20bright%20style%2C%20cinematic%20design&width=400&height=600&seq=hot-poster-10&orientation=portrait',
    backdrop: '',
    description: '钳工胡建林阴差阳错调入集团总部，在职场丛林中引发啼笑皆非的故事。',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲'],
    duration: '117分钟',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    views: 1560000,
  },
];

export const tvShows: Movie[] = [
  {
    id: 'tv-1',
    title: '繁花',
    enTitle: 'Blossoms Shanghai',
    year: 2024,
    category: 'tv',
    genre: ['剧情', '爱情', '年代'],
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20about%201990s%20Shanghai%2C%20nostalgic%20warm%20golden%20lighting%2C%20elegant%20vintage%20style%2C%20drama%20series%20poster%20design&width=400&height=600&seq=tv-poster-01&orientation=portrait',
    backdrop: '',
    description: '九十年代的上海，阿宝凭借改革开放的春风从默默无闻的青年变成商界后起之秀。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '30集',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 3800000,
  },
  {
    id: 'tv-2',
    title: '庆余年2',
    enTitle: 'Joy of Life 2',
    year: 2024,
    category: 'tv',
    genre: ['古装', '权谋', '喜剧'],
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20with%20ancient%20Chinese%20costume%2C%20palace%20intrigue%2C%20elegant%20gold%20and%20red%20tones%2C%20drama%20series%20poster&width=400&height=600&seq=tv-poster-02&orientation=portrait',
    backdrop: '',
    description: '范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '36集',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 4500000,
  },
  {
    id: 'tv-3',
    title: '长相思',
    enTitle: 'Lost You Forever',
    year: 2023,
    category: 'tv',
    genre: ['古装', '爱情', '奇幻'],
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20series%20poster%20with%20ethereal%20ancient%20Chinese%20aesthetic%2C%20dreamy%20pastel%20colors%2C%20romantic%20atmosphere%2C%20drama%20series%20poster&width=400&height=600&seq=tv-poster-03&orientation=portrait',
    backdrop: '',
    description: '上古时代，人、神、妖混居。流落大荒的高辛王姬玖瑶历经百年颠沛之苦，最终在清水镇落脚。',
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    duration: '39集',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 2900000,
  },
  {
    id: 'tv-4',
    title: '狂飙',
    enTitle: 'The Knockout',
    year: 2023,
    category: 'tv',
    genre: ['犯罪', '剧情', '悬疑'],
    rating: 9.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20TV%20series%20poster%20about%20police%20and%20gangsters%2C%20dark%20intense%20atmosphere%2C%20noir%20style%2C%20drama%20series%20poster%20design&width=400&height=600&seq=tv-poster-04&orientation=portrait',
    backdrop: '',
    description: '京海市一线刑警安欣与黑恶势力进行长达二十年的生死搏斗，揭开层层保护伞的故事。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    duration: '39集',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 5600000,
  },
  {
    id: 'tv-5',
    title: '与凤行',
    enTitle: 'The Legend of Shen Li',
    year: 2024,
    category: 'tv',
    genre: ['古装', '奇幻', '爱情'],
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20series%20poster%20with%20phoenix%20theme%2C%20ancient%20Chinese%20fantasy%20aesthetic%2C%20ethereal%20red%20and%20gold%2C%20drama%20series%20poster&width=400&height=600&seq=tv-poster-05&orientation=portrait',
    backdrop: '',
    description: '灵界碧苍王沈璃为掌握自己命运，在逃婚过程中受伤坠落人间，与上古神行止展开一段跨越三界的爱情。',
    director: '邓科',
    actors: ['赵丽颖', '林更新', '辛云来', '何与'],
    duration: '39集',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    views: 2200000,
  },
  {
    id: 'tv-6',
    title: '三体',
    enTitle: 'Three-Body',
    year: 2023,
    category: 'tv',
    genre: ['科幻', '悬疑', '剧情'],
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20Three%20Body%20poster%20with%20cosmic%20mystery%2C%20dark%20space%20theme%2C%20mysterious%20red%20planet%2C%20drama%20series%20poster%20design&width=400&height=600&seq=tv-poster-06&orientation=portrait',
    backdrop: '',
    description: '纳米科学家汪淼被警官史强带到联合作战中心，潜入神秘组织"科学边界"调查一系列科学家自杀事件。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    duration: '30集',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 3400000,
  },
  {
    id: 'tv-7',
    title: '大奉打更人',
    enTitle: 'Guardians of the Dafeng',
    year: 2024,
    category: 'tv',
    genre: ['古装', '悬疑', '喜剧'],
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20TV%20series%20poster%20with%20ancient%20detective%20theme%2C%20dark%20mysterious%20tone%2C%20period%20costume%2C%20drama%20series%20poster&width=400&height=600&seq=tv-poster-07&orientation=portrait',
    backdrop: '',
    description: '现代打工人杨凌意外穿越到大奉王朝，成为打更人许七安，利用现代知识破解奇案。',
    director: '邓科',
    actors: ['王鹤棣', '田曦薇', '刘奕君', '晏紫东'],
    duration: '40集',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 1850000,
  },
  {
    id: 'tv-8',
    title: '墨雨云间',
    enTitle: 'The Double',
    year: 2024,
    category: 'tv',
    genre: ['古装', '爱情', '复仇'],
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20romance%20revenge%20TV%20series%20poster%20with%20elegant%20ancient%20Chinese%20aesthetic%2C%20dramatic%20tension%2C%20dark%20and%20gold%20tones%2C%20drama%20series%20poster&width=400&height=600&seq=tv-poster-08&orientation=portrait',
    backdrop: '',
    description: '县令之女薛芳菲被丈夫陷害活埋，侥幸逃生后化身姜梨回到京城复仇雪恨。',
    director: '侣皓吉吉',
    actors: ['吴谨言', '王星越', '陈鑫海', '梁永棋'],
    duration: '40集',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    views: 1680000,
  },
];

export const animeShows: Movie[] = [
  {
    id: 'anime-1',
    title: '鬼灭之刃 柱训练篇',
    enTitle: 'Demon Slayer: Hashira Training',
    year: 2024,
    category: 'anime',
    genre: ['动画', '热血', '战斗'],
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20Demon%20Slayer%20poster%20with%20swordsmen%20and%20demons%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20dark%20tones%2C%20anime%20poster%20design&width=400&height=600&seq=anime-poster-01&orientation=portrait',
    backdrop: '',
    description: '炭治郎等人为迎接最终决战，在各柱的指导下进行严酷训练，为对抗鬼舞辻无惨做准备。',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    duration: '8集',
    region: '日本',
    isHot: true,
    isNew: true,
    views: 2100000,
  },
  {
    id: 'anime-2',
    title: '葬送的芙莉莲',
    enTitle: 'Frieren: Beyond Journeys End',
    year: 2023,
    category: 'anime',
    genre: ['动画', '奇幻', '冒险'],
    rating: 9.4,
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20anime%20Frieren%20poster%20with%20elf%20mage%20in%20peaceful%20landscape%2C%20melancholic%20warm%20atmosphere%2C%20beautiful%20scenery%2C%20anime%20poster%20design&width=400&height=600&seq=anime-poster-02&orientation=portrait',
    backdrop: '',
    description: '打倒魔王的魔法使芙莉莲在勇者死后，踏上了解人类情感的旅程，重新走过与昔日同伴一起走过的路。',
    director: '斋藤圭一郎',
    actors: ['种崎敦美', '市之濑加那', '小林千晃'],
    duration: '28集',
    region: '日本',
    isHot: false,
    isNew: false,
    views: 2800000,
  },
  {
    id: 'anime-3',
    title: '凡人修仙传',
    enTitle: 'A Record of a Mortals Journey',
    year: 2024,
    category: 'anime',
    genre: ['动画', '仙侠', '冒险'],
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20cultivation%20fantasy%20poster%20with%20immortal%20warrior%20in%20ancient%20Chinese%20setting%2C%20misty%20mountains%2C%20martial%20arts%20aesthetic%2C%20anime%20poster&width=400&height=600&seq=anime-poster-03&orientation=portrait',
    backdrop: '',
    description: '普通少年韩立出身平凡，为求长生踏入修仙之路，凭借谨慎坚毅的性格一步步攀登仙道巅峰。',
    director: '王裕仁',
    actors: ['钱文青', '李诗萌', '刘琮'],
    duration: '更新至76集',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 1950000,
  },
  {
    id: 'anime-4',
    title: '间谍过家家 第二季',
    enTitle: 'Spy x Family Season 2',
    year: 2023,
    category: 'anime',
    genre: ['动画', '喜剧', '动作'],
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20Spy%20Family%20poster%20with%20spy%20family%20of%20three%2C%20fun%20colorful%20style%2C%20action%20comedy%20feel%2C%20anime%20poster%20design&width=400&height=600&seq=anime-poster-04&orientation=portrait',
    backdrop: '',
    description: '顶级间谍"黄昏"为执行任务组建临时家庭，却不知"女儿"是超能力者，"妻子"是杀手。',
    director: '古桥一浩',
    actors: ['江口拓也', '种崎敦美', '早见沙织'],
    duration: '12集',
    region: '日本',
    isHot: false,
    isNew: false,
    views: 2400000,
  },
];

export const varietyShows: Movie[] = [
  {
    id: 'variety-1',
    title: '奔跑吧 第十二季',
    enTitle: 'Keep Running S12',
    year: 2024,
    category: 'variety',
    genre: ['真人秀', '竞技', '搞笑'],
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20Keep%20Running%20with%20celebrities%20running%20outdoors%2C%20bright%20sunny%20colors%2C%20energetic%20fun%20vibe%2C%20variety%20show%20poster&width=400&height=600&seq=variety-poster-01&orientation=portrait',
    backdrop: '',
    description: '常驻嘉宾与飞行嘉宾组成奔跑团，在各地完成各种趣味挑战任务，传递快乐和正能量。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    duration: '12期',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 1600000,
  },
  {
    id: 'variety-2',
    title: '歌手2024',
    enTitle: 'Singer 2024',
    year: 2024,
    category: 'variety',
    genre: ['音乐', '竞技', '真人秀'],
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20variety%20show%20poster%20Singer%202024%20with%20stage%20performance%2C%20dramatic%20stage%20lighting%2C%20concert%20atmosphere%2C%20variety%20show%20poster&width=400&height=600&seq=variety-poster-02&orientation=portrait',
    backdrop: '',
    description: '顶级歌手同台竞技，全开麦真唱直播，用音乐实力征服观众，争夺年度歌王桂冠。',
    director: '洪涛',
    actors: ['那英', '汪苏泷', 'Faouzia', 'Chanté Moore'],
    duration: '12期',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    views: 2300000,
  },
  {
    id: 'variety-3',
    title: '花儿与少年·好友记',
    enTitle: 'Divas Hit the Road',
    year: 2024,
    category: 'variety',
    genre: ['旅行', '真人秀', '生活'],
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20travel%20variety%20show%20poster%20with%20celebrities%20in%20exotic%20location%2C%20beautiful%20scenery%2C%20warm%20golden%20sunset%20light%2C%20variety%20show%20poster&width=400&height=600&seq=variety-poster-03&orientation=portrait',
    backdrop: '',
    description: '一群明星好友结伴出游，在异国他乡展开充满欢笑与感动的旅程，展现真实友情。',
    director: '李超',
    actors: ['秦海璐', '秦岚', '辛芷蕾', '赵昭仪', '王安宇'],
    duration: '12期',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    views: 1450000,
  },
  {
    id: 'variety-4',
    title: '哈哈哈哈哈 第四季',
    enTitle: 'HaHaHaHaHa S4',
    year: 2024,
    category: 'variety',
    genre: ['真人秀', '旅行', '搞笑'],
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20travel%20variety%20show%20poster%20with%20funny%20celebrities%20on%20road%20trip%2C%20humorous%20chaotic%20scene%2C%20bright%20outdoor%20setting%2C%20variety%20show%20poster&width=400&height=600&seq=variety-poster-04&orientation=portrait',
    backdrop: '',
    description: '五哈旅行团再度集结，以穷游的方式走遍中国大地，在旅途中体验各种奇葩职业和风土人情。',
    director: '李睿',
    actors: ['邓超', '陈赫', '鹿晗', '范志毅', '宝石Gem'],
    duration: '12期',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    views: 1250000,
  },
];

export const allMovies: Movie[] = [
  ...heroMovies,
  ...latestMovies,
  ...hotRanking,
  ...tvShows,
  ...animeShows,
  ...varietyShows,
];

export function getMoviesByCategory(slug: string): Movie[] {
  const uniqueMap = new Map<string, Movie>();
  allMovies
    .filter((m) => m.category === slug)
    .forEach((m) => uniqueMap.set(m.id, m));
  return Array.from(uniqueMap.values());
}

export function getMovieById(id: string): Movie | undefined {
  return allMovies.find((m) => m.id === id);
}

export function getRelatedMovies(movie: Movie, count: number = 6): Movie[] {
  const sameCategory = allMovies.filter(
    (m) => m.category === movie.category && m.id !== movie.id
  );
  const uniqueMap = new Map<string, Movie>();
  sameCategory.forEach((m) => uniqueMap.set(m.id, m));
  return Array.from(uniqueMap.values()).slice(0, count);
}